// @ts-nocheck
import { useTranslation } from 'react-i18next';
// import { useDispatch } from 'react-redux';
// import { letterPrint } from '../../../store/Ame/ameRequestSlice';
import { Link } from 'react-router-dom';
import { ntxAPI } from '../../../API/axiosNeatex';
import { Modal, Button } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import NtxCustomModal from '../../../components/Modal/NtxCustomModal';

const HistoryList = ({ data }) => {
  const { t, i18n } = useTranslation();
  //#region

  // const handlePrint2 = async () => {
  //   const fileName = i18n.language === 'en' ? data?.selectPersonName : data?.selectPersonName2;

  //   try {
  //     // إرسال الطلب للحصول على الملف
  //     const response = await ntxAPI.post(
  //       `Reports/LetterPrint?AmeTransectionHistoryId=${data?.transectionHistoryId}`,
  //       null, // لا حاجة إلى جسم الطلب هنا
  //       {
  //         responseType: 'blob', // لضمان استلام ملف ثنائي
  //       }
  //     );

  //     // إنشاء وتنزيل الملف
  //     downloadFile(response.data, `${fileName} | Neatix-Erp.pdf`);
  //   } catch (error) {
  //     console.error('Error downloading file:', error);
  //     alert('Failed to download the file. Please try again later.');
  //   }
  // };

  // دالة لإنشاء وتنزيل الملف
  // const downloadFile = (data, fileName) => {
  //   const blob = new Blob([data], {
  //     type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  //   });

  //   const url = window.URL.createObjectURL(blob);
  //   const a = document.createElement('a');
  //   a.href = url;
  //   a.download = fileName;
  //   document.body.appendChild(a);
  //   a.click();
  //   a.remove();
  //   window.URL.revokeObjectURL(url); // تنظيف URL بعد التنزيل
  // };

  //#endregion

  const renderStatusMessage = (status) => {
    switch (status) {
      case 'APPROVED':
        return (
          <div>
            <span className="text-theme h6">
              {/* <Link to="#" className="fw-bold" onClick={handlePrint2}>
                تم اعتماد الطلب. اضغط هنا لتحميل أو مشاهدة الخطاب
                <i className="bi bi-filetype-pdf fa-lg mx-2 fs-5 fw-bold"></i>
              </Link> */}
              <PrintFile
                transectionHistoryId={data?.transectionHistoryId}
                fileName={i18n.language === 'en' ? data?.selectPersonName : data?.selectPersonName2}
              />
            </span>
          </div>
        );

      case 'REJECTED':
        return (
          <div>
            <span className="text-danger h6">
              تم رفض الطلب. يُرجى مراجعة التفاصيل واتخاذ الإجراءات اللازمة.
            </span>
          </div>
        );

      case 'IN PROGRESS':
        return (
          <div>
            <span className="text-muted h6">
              الطلب قيد المعالجة. يُرجى الانتظار حتى يتم إتمام جميع الموافقات اللازمة.
            </span>
          </div>
        );

      default:
        return null;
      //  (
      //   <div>
      //     <span className="text-muted h6">حالة غير معروفة. يُرجى التحقق.</span>
      //   </div>
      // );
    }
  };

  return (
    <>
      {/* <div className="table-responsive   bg-inverse bg-opacity-10 rounded-4"> */}
      <div className="table-responsive  rounded-2 text-center">
        <table className="table table-hover text-nowrap mb-0 ">
          <thead className="bg-inverse bg-opacity-15">
            <tr>
              <th>{t('Name')}</th>
              <th>{t('Date')}</th>
              <th>{t('Procedure')}</th>
              <th>{t('Comments')}</th>
            </tr>
          </thead>

          <tbody>
            {data &&
              data?.history?.map((item, idx) => (
                <tr key={idx++}>
                  <td className="align-middle">
                    {i18n.language === 'ar' ? item.name2 : item.name}
                  </td>
                  <td className="align-middle">{item.date}</td>

                  <td className="align-middle">
                    {item.action === 'CREATED' ? (
                      <span className=" badge border border-primary  text-primary  px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center ">
                        <i className="fa fa-circle fs-15px fa-fw me-5px"></i>
                        {t('CREATED')}
                      </span>
                    ) : item.action === 'QUESTION' ? (
                      <span className="badge border border-indigo text-indigo fw-bold px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center">
                        <i className="bi bi-question-circle-fill fs-18px fa-fw me-5px"></i>
                        {t('QUESTION')}
                      </span>
                    ) : item.action === 'ANSWER' ? (
                      <span className="badge border border-purple text-purple px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center">
                        <i className="bi bi-reply-fill fs-18px fa-fw me-5px"></i>
                        {t('ANSWER')}
                      </span>
                    ) : item.action === 'TRANSFER' ? (
                      <span className="badge border border-warning text-warning px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center">
                        <i className="bi bi-sign-turn-right-fill fs-18px fa-fw me-5px"></i>
                        {t('TRANSFER')}
                      </span>
                    ) : item.action === 'REJECTED' ? (
                      <span className="badge border border-danger  text-danger  px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center">
                        <i className="bi bi-x-circle-fill fs-18px fa-fw me-5px"></i>
                        {t('REJECTED')}
                      </span>
                    ) : item.action === 'APPROVED' ? (
                      <span className="badge border border-success  text-success  px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center">
                        <i className="bi bi-check-square-fill fs-18px fa-fw me-5px"></i>
                        {t('APPROVED')}
                      </span>
                    ) : item.action === 'PENDING' ? (
                      <span className="badge border border-warning  text-warning  px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center">
                        <i className="bi-hourglass-split fs-18px fa-fw me-5px"></i>
                        {t('PENDING')}
                      </span>
                    ) : item.action === 'WAITING' ? (
                      <span className="badge border border-secondary  text-secondary  px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center">
                        <i className="bi bi-clock-history fs-18px fa-fw me-5px"></i>
                        {t('WAITING')}
                      </span>
                    ) : item.action === 'WAITING_NOTF' ? (
                      <span className="badge border border-secondary   text-secondary   px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center">
                        <i className="bi bi-bell text-theme  fs-18px fa-fw me-5px"></i>
                        {t('WAITING_NOTF')}
                      </span>
                    ) : item.action === 'NOTIFIED' ? (
                      <span className=" badge border border-info   text-info   px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center">
                        <i className="bi bi-bell fs-18px fa-fw me-5px"></i>
                        {t('NOTIFIED')}
                      </span>
                    ) : item.action === 'DELEGATE' ? (
                      <span className=" badge border border-info  text-info   px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center">
                        <i className="bi bi-person-fill fs-18px fa-fw me-5px"></i>
                        <i className="bi bi-arrow-right fs-18px fa-fw me-5px"></i>
                        {t('Delegated')}
                      </span>
                    ) : (
                      ''
                    )}
                  </td>

                  <td className="align-middle">{item.userComment}</td>
                </tr>
              ))}
            {data?.isPrintTemplate && (
              // <tr>
              //   <td className="align-middle" colSpan={4}>
              //     <div className="col-md-12 d-flex justify-content-center align-items-center h-100">
              //       <div className="p-3 w-100 text-center">{renderStatusMessage(data?.status)}</div>
              //     </div>
              //   </td>
              // </tr>
              <tr>
                <td className="align-middle" colSpan={4}>
                  <div className="col-md-12 d-flex justify-content-center align-items-center h-100">
                    <div className="p-3 w-100 text-center">
                      {renderStatusMessage(data?.status)}
                      {/* استخدم مكون الطباعة هنا */}
                    </div>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default HistoryList;


const PrintFile = ({ transectionHistoryId, fileName }) => {
  const { t } = useTranslation();
  const [fileUrl, setFileUrl] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // دالة لإرسال طلب والحصول على الملف وعرضه في iframe
  const handleShowFile = async () => {
    setLoading(true);
    setError(null);
    setShowModal(true);
    try {
      const response = await ntxAPI.post(
        `Reports/LetterPrint?AmeTransectionHistoryId=${transectionHistoryId}`,
        null,
        { responseType: 'blob' }
      );

      // إنشاء URL للملف وعرضه في iframe
      const blob = new Blob([response.data], {
        type: 'application/pdf', // يجب التأكد من نوع الملف
      });
      const url = window.URL.createObjectURL(blob);
      setFileUrl(url);
      // setShowModal(true);
    } catch (error) {
      console.error('Error fetching file:', error);
      setError(t('حدث خطأ أثناء تحميل الملف.'));
    } finally {
      setLoading(false); // Stop loading
    }
  };

  console.log(loading);
  

  return (
    <div>
      <Button variant="primary" onClick={handleShowFile}>
        عرض الخطاب
      </Button>

      
      <NtxCustomModal
        width="98%"
        show={showModal}
        setShow={setShowModal}
        showHeader={false}
        centered={true}
        bodyClassName="p-0">
        <div style={{ height: '90vh', paddingBottom: 3 }} className="border border-1 border-theme ">
          {/* Loading State */}
          {loading && (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{
                margin: 0,
                height: 'calc(100% - 49px)',
              }}>
              <div className="spinner-grow text-theme" role="status">
                <span className="visually-hidden">{t('تحميل')}</span>
              </div>
            </div>
          )}

          {/* Error State */}
          {!loading && error && (
            <div
              className="d-flex justify-content-center align-items-center text-danger"
              style={{
                margin: 0,
                height: 'calc(100% - 49px)',
              }}>
              <p>{error}</p>
            </div>
          )}

          {/* PDF Viewer */}
          {!loading && !error && fileUrl && (
            <iframe
              src={fileUrl}
              width="100%"
              height="100%"
              title="PDF Preview"
              style={{
                margin: 0,
                height: 'calc(100% - 50px)',

                boxShadow: '0 1px 10px var(--bs-theme)',
                border: '1px solid #ccc',
              }}></iframe>
          )}

          {/* Modal Footer */}
          <div className="text-center">
            <button
              className="btn btn-lg btn-theme w-25 rounded-0"
              onClick={() => {
                setShowModal(false);
                setFileUrl(null);
                setError(null);
                window.URL.revokeObjectURL(fileUrl);
              }}>
              {t('إلغاء')}
            </button>
          </div>
        </div>
      </NtxCustomModal>
    </div>
  );
};
